import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { AccountService } from '@core/auth/account.service';
import { LoginService } from '@core/login/login.service';
import { Account } from '@core/auth/account.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jhi-home-backoffice',
  templateUrl: './home-backoffice.component.html',
  imports: [NgIf, TranslateModule],
  standalone: true,
})
export class HomeBackofficeComponent implements OnInit {
  account?: Account | null;
  example1 = 100;
  example2 = 200;
  example3 = 300;
  example4 = 400;

  constructor(private accountService: AccountService, private loginService: LoginService) {}

  ngOnInit(): void {
    this.accountService.identity().subscribe(account => (this.account = account));
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  login(): void {
    this.loginService.login();
  }
}
